/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { SOCIAL_PLATFORMS, SOCIAL_PROVIDERS } from '@repo/config/social';
import { z } from 'zod';

export const SOCIAL_POST_STATUSES = ['queued', 'publishing', 'published', 'failed'] as const;

export const socialPostStatusSchema = z.enum(SOCIAL_POST_STATUSES);

export type ISocialPostStatus = z.infer<typeof socialPostStatusSchema>;

export const socialPostListItemSchema = z.object({
  id: z.number(),
  socialVideoId: z.number(),
  challengeId: z.number(),
  phrase: z.string(),
  version: z.number(),
  channelId: z.number(),
  provider: z.enum(SOCIAL_PROVIDERS),
  platform: z.enum(SOCIAL_PLATFORMS),
  channelName: z.string(),
  status: socialPostStatusSchema,
  permalink: z.string().nullable(),
  error: z.string().nullable(),
  posterUrl: z.string().nullable(),
  publishedAt: z.number().nullable(),
  createdAt: z.number(),
});

export type ISocialPostListItem = z.infer<typeof socialPostListItemSchema>;
